import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { ToolCallCard } from "./ToolCallCard";
import { UserMessage } from "./UserMessage";
import { AssistantMessage } from "./AssistantMessage";
// Helper function to check if a message is a BasicChatMessage
const isBasicChatMessage = (message) => {
    return 'sender' in message && ('text' in message || 'components' in message);
};
// Helper function to check if a message is a tool call message
const isToolMessage = (message) => {
    return 'role' in message && message.role === 'tool' && !!message.toolCall;
};
/**
 * Routes a message to the appropriate component based on its type
 * This is the single point of decision for message rendering
 */
export const ChatMessageItem = memo(({ message, onAddToPrompt, onEditMessage, fetchMentionItems, onRequestMentionUpload, uploadingFiles = [], }) => {
    // Debug log removed for cleaner console
    // Route 1: Tool Call Message (expandable card)
    if (isToolMessage(message)) {
        return (_jsx("div", { className: "w-full", children: _jsx(ToolCallCard, { toolCall: message.toolCall }) }, message.id));
    }
    // Route 2: Basic Chat Message (user or assistant)
    if (isBasicChatMessage(message)) {
        return message.sender === 'user'
            ? (_jsx(UserMessage, { message: message, onAddToPrompt: onAddToPrompt, onEditMessage: onEditMessage, fetchMentionItems: fetchMentionItems, onRequestMentionUpload: onRequestMentionUpload, uploadingFiles: uploadingFiles }))
            : _jsx(AssistantMessage, { message: message });
    }
    // Unknown message type
    return null;
});
ChatMessageItem.displayName = 'ChatMessageItem';
